<template>
	<div :class="[settings.variants[variant], center ? 'mx-auto' : null]">
		<slot />
	</div>
</template>

<script setup>
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkContainer');

defineProps({
	center: {
		type: Boolean,
		required: false,
		default: true,
	},
	variant: {
		type: String,
		required: false,
		default: 'default',
	},
});
</script>
